import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';
import { Grid } from './../../../themes/default';
import { Section, Content, Main, Buttons, FormContent, FormActions } from './../../../components/includes/container';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Ttolbar } from './../../../components/includes/ui/table';
import { SnackbarStatic } from './../../../components/includes/snackbar';
import { InputTextField, SelectField, OptionField } from './../../../components/includes/ui/input';
import { Btn } from './../../../components/includes/ui';
import { buildSlug } from './../../../utilities/utils';
import { PageService, CategoryService } from './../../../services';


import VALIDATION from './../../../config/validation';
//import TEMPLATES from './../../../config/templates';
import CONSTANT from './../../../config/constant';

const selector = formValueSelector('CategoryCreate');

const validate = values => {

  const errors = {}

  if (values.has_parent === '-1') {
    errors.has_parent = VALIDATION.required;
  }

  if (values.type === '-1') {
    errors.type = VALIDATION.required;
  }

  if (!values.name) {
    errors.name = VALIDATION.required;
  }else if(values.name.length > 255){
    errors.name = 'El tamaño máximo es de 255 caracteres.';
  }
  //
  // if (!values.description) {
  //   errors.surname = VALIDATION.required;
  // }
  //
  // if (values.status === '-1') {
  //   errors.status = VALIDATION.required;
  // }
  //
  // if (values.template === '-1') {
  //   errors.template = VALIDATION.required;
  // }

  return errors

};

class CategoryCreate extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false,
      sending: false,
      parentCategories: [],
      parentPages: [],
      slugCategory: null,
      alertShow: false,
      alertVariant: 'warning',
      alertMessage: null,
    };
  }

  componentDidMount(){

    // @Service
    // @Description: Categories
    this._FindCategoriesByPrimaryLevel();

    // @Service
    // @Description: Paginas
    this._FindAllPages();

  }

  /*
  ** @Service
  ** @Description: Find categories by first level
  */

  _FindCategoriesByPrimaryLevel = () => {

    CategoryService.findPrimaryLevel().then((response) => {

      // @SetState
      this.setState({ parentCategories: response.categories });

    }).catch((error) => {

      this.props.AlertShow({ open: true, variant: 'error', message: Error.internal });

    });

  }

  /*
  ** @Service
  ** @Description: Find categories by first level
  */

  _FindAllPages = () => {

    PageService.findAll().then((response) => {

      // @SetState
      this.setState({ parentPages: response.pages });

    }).catch((error) => {

        this.props.AlertShow({ open: true, variant: 'error', message: Error.internal });

    });

  }

  /*
  ** @Service
  ** @Description: New
  */

  _Create = (values) => {

    CategoryService.create(values).then((response) => {

      /**
      * @Service find all by page
      */
      this.props.history.push('/categories');

      /**
      * @Dispatch for alert success message
      */
      this.props.AlertShow({ open: true, variant: 'success', message: `Exitio, la categoría fue creada.` });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error.data.message });

    });

  }

  handleSubmitForm = (values) => {

    let _values = Object.assign(values, { slug: this.state.slugCategory });

    this._Create(_values);

  }

  /*
  ** @Event
  ** @Description: Change parent categoria value
  */

  handleHasParentChange = (e) => {

    const value = Number(e.target.value);

    if (value === CONSTANT.categories.level.secondary){
      if(this.state.parentCategories.length === 0){
        this.setState({
          alertShow: true,
          alertMessage: 'No encontramos categorías primarias para poder asociar.'
        });
      }
    } else {

      this.setState({
        alertShow: false,
        alertMessage: null
      });

    }

    this.props.dispatch(change('CategoryCreate', 'type', String(-1) ));

  }

  /*
  ** @Event
  ** @Description: Change name value
  */

  handleNameChange = (e) => {
    this.setState({ slugCategory: buildSlug(e.target.value) });
  }

  /*
  ** @Event
  ** @Description: Change name value
  */

  handleTypeChange = (e) => {

    const value = Number(e.target.value);

    this.setState({
      alertShow: false,
      alertMessage: null
    });

    // @Pagina interna
    if (value === 2) {

      if (this.state.parentPages.length === 0) {
        this.setState({
          alertShow: true,
          alertMessage: 'No encontramos páginas para poder asociar.'
        });
      }

    }

  }

  render() {

    //const { activeStep, parentCategories, parentPages, slugCategory } = this.state;
    const { sending, parentCategories, parentPages, alertShow, alertVariant, alertMessage } = this.state;
    const { handleSubmit, invalid, hasParentValue, pageTypeValue } = this.props;

    return (
      <Section>
        <ToolbarPrimary title="Categorías"/>
        <BreadcrumbItem to='/categories'>Categorías</BreadcrumbItem>
        <BreadcrumbItem to='/categories/create'>Crear</BreadcrumbItem>
        <Content>

          <Main>

            <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>

              <Ttolbar title="Creación de categoría"/>

              <FormContent enabledActions>

                <Grid container spacing={24}>

                  { (alertShow && alertMessage) && (
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <SnackbarStatic
                          icon="info"
                          variant={ alertVariant }
                          message={ alertMessage }
                          open={true}
                          fullWidth hideClose/>
                    </Grid>
                  )}

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container spacing={24}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Field
                            name="has_parent"
                            component={ SelectField }
                            onChange={ (e) => this.handleHasParentChange(e) }
                            label="Nivel de la categoría" required>
                              <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                              <OptionField
                                key={ CONSTANT.categories.level.primary }
                                value={ CONSTANT.categories.level.primary }>
                                Navegación principal (Header)
                              </OptionField>
                              <OptionField
                                key={ CONSTANT.categories.level.secondary }
                                value={ CONSTANT.categories.level.secondary }>
                                  Navegación secundaria (Header — Desplegable)
                              </OptionField>
                              <OptionField
                                key={ CONSTANT.categories.level.tertiary }
                                value={ CONSTANT.categories.level.tertiary }>
                                  Navegación terciaria (Footer)
                              </OptionField>
                              <OptionField
                                key={ CONSTANT.categories.level.hidden }
                                value={ CONSTANT.categories.level.hidden }>
                                  No visible
                              </OptionField>
                        </Field>
                      </Grid>

                      { hasParentValue === CONSTANT.categories.level.secondary && (
                         parentCategories.length > 0 && (
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Field
                                name="parent"
                                component={ SelectField }
                                label="¿Cuál es la categoría principal?" required>
                                  <OptionField key="1" value="-1">Seleccionar...</OptionField>
                                    { parentCategories.map(category => {
                                      return(
                                        <OptionField key={ category._id } value={ category._id }>{ category.name }</OptionField>
                                      )
                                    })}
                            </Field>
                          </Grid>
                        )
                      )}

                    </Grid>
                  </Grid>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container spacing={24}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Field
                            name="type"
                            component={ SelectField }
                            onChange={ (e) => this.handleTypeChange(e) }
                            label="Objetivo de la categoría" required>
                              <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                              { hasParentValue === 1 && (
                                <OptionField
                                  key={ CONSTANT.categories.objetive.secondary }
                                  value={ CONSTANT.categories.objetive.secondary }>
                                    Desplegable (Navegación secundaria)
                                </OptionField>
                              )}
                              <OptionField
                                key={ CONSTANT.categories.objetive.link }
                                value={ CONSTANT.categories.objetive.link }>
                                  Módulo interno (Enlace)
                              </OptionField>
                              <OptionField
                                key={ CONSTANT.categories.objetive.page }
                                value={ CONSTANT.categories.objetive.page }>
                                  Página interna (Page)
                              </OptionField>
                              <OptionField
                                key={ CONSTANT.categories.objetive.url }
                                value={ CONSTANT.categories.objetive.url }>
                                  Página Externa (Url)
                              </OptionField>
                              <OptionField
                                key={ CONSTANT.categories.objetive.iframe }
                                value={ CONSTANT.categories.objetive.iframe }>
                                  Página Embebida (Iframe)
                              </OptionField>
                        </Field>
                      </Grid>

                      {/*
                          -----------------------------
                          ------- INTERNAL PAGE -------
                          -----------------------------
                      */}

                      { pageTypeValue === CONSTANT.categories.objetive.page && (
                        parentPages.length > 0 && (
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Field
                                name="page"
                                component={ SelectField }
                                label="Seleccione la página de la categoría" required>
                                  <OptionField key="1" value="-1">Seleccionar...</OptionField>
                                  { parentPages.length > 0 && (
                                    parentPages.map(page => {
                                      return(
                                        <OptionField key={ page._id } value={ page._id }>{ page.title }</OptionField>
                                      )
                                    })
                                  )}
                            </Field>
                          </Grid>
                        )
                      )}

                      {/*
                          -----------------------------
                          -- EXTERNAL/INTERNAL PAGE ---
                          -----------------------------
                      */}

                      { (pageTypeValue === CONSTANT.categories.objetive.url || pageTypeValue === CONSTANT.categories.objetive.iframe) && (
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Field
                              label="Ingrese la url del sitio"
                              name="link"
                              component={ InputTextField }
                              type="text"
                              placeholder="https://www.google.com.ar"
                          />
                        </Grid>
                      )}

                      {/*
                          -----------------------------
                          -- EXTERNAL/INTERNAL PAGE ---
                          -----------------------------
                      */}

                      { (pageTypeValue === CONSTANT.categories.objetive.link) && (
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Field
                              label="Ingrese la url del modulo"
                              name="module"
                              component={ InputTextField }
                              type="text"
                              placeholder="/servicios/asistencia"
                          />
                        </Grid>
                      )}

                    </Grid>
                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Field
                        name="name"
                        component={ InputTextField }
                        label="¿Cuál es el nombre de la categoría?"
                        type="text"
                        required
                        onChange={ (e) => this.handleNameChange(e) }
                    />
                  </Grid>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Field
                        name="position"
                        component={ InputTextField }
                        label="¿Cuál es la posición de la categoría?"
                        type="number"
                        required
                    />
                  </Grid>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Field
                        name="target"
                        component={ SelectField }
                        label="¿Cómo abrimos la nueva página?" required>
                          <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                          <OptionField key="_self" value="_self">Misma Página</OptionField>
                          <OptionField key="_blank" value="_blank">Nueva Página</OptionField>
                    </Field>
                  </Grid>

                </Grid>

              </FormContent>

              <FormActions>
                <Grid container>
                  <Grid item lg={6} md={6} sm={6} xs={6}>
                    <Buttons>
                      <Btn aria-label="Volver" icon="back" color="secondary" component={ NavLink } to="/pages">
                        Volver
                      </Btn>
                    </Buttons>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={6}>
                    <Buttons align="right">
                      <Btn aria-label="Guardar página" icon="add" color="success" type="submit" disabled={ invalid } loading={ sending }>
                        Guardar página
                      </Btn>
                    </Buttons>
                  </Grid>
                </Grid>
              </FormActions>

            </form>

          </Main>

        </Content>
      </Section>
    )
  }
}

CategoryCreate = reduxForm({
  form: 'CategoryCreate',
  validate,
  initialValues: {
    type: '-1',
    has_parent: '-1',
    target: '-1'
  }
})(CategoryCreate);

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    },
  }
}

CategoryCreate = connect(
  state => {
    const nameValue = selector(state, 'name');
    const hasParentValue = Number(selector(state, 'has_parent'));
    const pageTypeValue = Number(selector(state, 'type'));
    return {
      nameValue, hasParentValue, pageTypeValue
    }
  }
)(CategoryCreate);

export default connect(mapStateToProps, mapDispatchToProps)(CategoryCreate);
